import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1a3a52',
      light: '#2d4e66',
      dark: '#0f2838',
    },
    secondary: {
      main: '#8b7355',
      light: '#a08870',
      dark: '#6d5a44',
    },
    background: {
      default: '#faf4e9',
      paper: '#faf4e9',
    },
    text: {
      primary: '#1a3a52',
      secondary: '#2d4e66',
    },
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    h1: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 400,
      fontSize: '2.5rem',
      letterSpacing: '0.5px',
      color: '#1a3a52',
    },
    h2: {
      fontFamily: '"Open Sans", sans-serif',
      fontWeight: 400,
      fontSize: '2rem',
      letterSpacing: '0.5px',
      color: '#1a3a52',
    },
    h3: {
      fontFamily: '"Open Sans", sans-serif',
      fontWeight: 400,
      fontSize: '1.75rem',
      letterSpacing: '0.5px',
      color: '#1a3a52',
    },
    h4: {
      fontFamily: '"Open Sans", sans-serif',
      fontWeight: 400,
      fontSize: '1.5rem',
      letterSpacing: '0.5px',
      color: '#1a3a52',
    },
    h5: {
      fontFamily: '"Open Sans", sans-serif',
      fontWeight: 400,
      fontSize: '1.25rem',
      letterSpacing: '0.5px',
      color: '#1a3a52',
    },
    h6: {
      fontFamily: '"Open Sans", sans-serif',
      fontWeight: 400,
      fontSize: '1.1rem',
      letterSpacing: '0.5px',
      color: '#1a3a52',
    },
    body1: {
      fontFamily: '"Open Sans", sans-serif',
      fontSize: '1rem',
      lineHeight: 1.7,
      color: '#2d4e66',
    },
    body2: {
      fontFamily: '"Open Sans", sans-serif',
      fontSize: '0.875rem',
      lineHeight: 1.6,
      color: '#2d4e66',
    },
    button: {
      fontFamily: '"Open Sans", sans-serif',
      textTransform: 'none',
      fontWeight: 500,
      letterSpacing: '0.5px',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          padding: '10px 24px',
          fontSize: '0.95rem',
          fontWeight: 500,
        },
        contained: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        },
      },
    },
  },
});

export default theme;
